export default "__VITE_ASSET__DMBH35Ct__"